module.exports = __webpack_public_path__ + "/3de25a8c0e4e8983ce62433bb4336ad6.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/googledocs_logo.svg
 ** module id = 1655
 ** module chunks = 0
 **/